// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export interface UserDefinition {
  /** The id of the user. */
  id?: string;
}
